import loadable from '@loadable/component';
import { useEffect } from 'react';

import { bool, object } from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { useConfiguration } from '../../context/configurationContext';
import { fetchCustomListings } from './CMSPage.duck';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const dispatch = useDispatch();
  const config = useConfiguration();
  const { params, pageAssetsData, inProgress, error } = props;
  const pageId = params.pageId || props.pageId;

  useEffect(() => {
    if (
      pageAssetsData?.[pageId] &&
      pageAssetsData[pageId].data.sections[0].sectionId &&
      pageAssetsData[pageId].data.sections[0].sectionId.includes('fetch-custom-data')
    ) {
      dispatch(fetchCustomListings(config, pageAssetsData[pageId].data.sections));
    }
  }, [JSON.stringify(pageAssetsData)]);

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(
  withRouter,
  connect(mapStateToProps)
)(CMSPageComponent);

export default CMSPage;
